import React from 'react';

const Payment = () => {
    return (
        <div>
            <h2>Payment system comming soon...</h2>
            <img src="https://i.ibb.co/Z6D3xhd/payment.png" style={{ width: '50%' }} alt='' />
        </div>
    );
};

export default Payment;